export type StringingStatus =
  | "RECEIVED"
  | "STRINGING"
  | "READY"
  | "COLLECTED"
  | "CANCELLED";
export interface StringingClient {
  id: number;
  name: string;
  mobile: string | null;
  notes: string | null;
  userId: number | null;
  version: number;
  createdAt: string;
  orderCount: number;
}
export interface StringingServiceItem {
  id: number;
  name: string;
  description: string | null;
  laborAmount: number;
  materialsAmount: number;
  currency: string;
  active: boolean;
  version: number;
}
export interface StringingOrder {
  id: number;
  clientId: number;
  clientName: string;
  clientMobile: string | null;
  serviceId: number | null;
  sourceRequestId: number | null;
  racquet: string;
  mainsString: string;
  crossesString: string;
  mainsTension: number;
  crossesTension: number;
  tensionUnit: "LB" | "KG";
  playerSuppliesStrings: boolean;
  dueAt: string;
  laborAmount: number;
  materialsAmount: number;
  currency: string;
  notes: string | null;
  status: StringingStatus;
  assignedUserId: number | null;
  assignedName: string | null;
  paidAmount: number;
  version: number;
  createdAt: string;
  updatedAt: string;
}
export interface StringingDetail {
  order: StringingOrder;
  activity: {
    id: number;
    action: string;
    actorName: string;
    createdAt: string;
  }[];
  payments: {
    id: number;
    amount: number;
    currency: string;
    method: string;
    paidOn: string;
    createdAt: string;
  }[];
}
export interface StringingPage<T> {
  items: T[];
  hasMore: boolean;
  nextCursor: number | null;
}
export interface StringingInquiry {
  email?: string | null;
  message?: string | null;
  id: number;
  userId: number;
  name: string;
  mobile: string | null;
  contactMethod: string;
  status: string;
  createdAt: string;
  orderId: number | null;
  clientId: number | null;
}
export interface StringingOverview {
  tenantId: number;
  businessName: string;
  timezone: string;
  activeOrders: number;
  dueToday: number;
  readyForPickup: number;
  clientCount: number;
  money: { currency: string; outstanding: number; received: number }[];
  queue: StringingOrder[];
  ready: StringingOrder[];
}
export interface StringingClientInput {
  requestId: string;
  name: string;
  mobile: string | null;
  notes: string | null;
  userId: number | null;
}
export interface StringingOrderInput {
  requestId: string;
  clientId: number;
  serviceId: number | null;
  sourceRequestId: number | null;
  racquet: string;
  mainsString: string;
  crossesString: string;
  mainsTension: number;
  crossesTension: number;
  tensionUnit: "LB" | "KG";
  playerSuppliesStrings: boolean;
  dueAt: string;
  laborAmount: number;
  materialsAmount: number;
  currency: string;
  notes: string | null;
  assignedUserId: number | null;
}
export const stringingStatusLabel = (value: StringingStatus) =>
  ({
    RECEIVED: "Received",
    STRINGING: "Stringing",
    READY: "Ready",
    COLLECTED: "Collected",
    CANCELLED: "Cancelled",
  })[value];
export const stringingTotal = (order: StringingOrder) =>
  Number(order.laborAmount) + Number(order.materialsAmount);
export const stringingBalance = (order: StringingOrder) =>
  Math.max(
    0,
    Math.round((stringingTotal(order) - Number(order.paidAmount)) * 100) / 100,
  );
